import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const Gender = lazyWithPreload(() => import('./Gender'))
export const GenderV2 = lazyWithPreload(() => import('./GenderV2'))
